import React from 'react';

// Components

import AddedToBOBModal from '../../components/broker/modals/AddedToBOBModal';
import BecomeAORModal from '../../components/broker/modals/BecomeAORModal';
import LocateAssistanceModal from '../../components/common/modals/LocateAssistanceModal';
import SaveResultModal from '../../components/common/modals/SaveResultModal';
import SessionIdleWarningModal from '../../components/common/modals/SessionIdleWarningModal';
import AppInProgressModal from '../../components/common/modals/AppInProgressModal';
import RequestErrorModal from '../../components/common/modals/RequestErrorModal';
import ResubmitModal from '../../components/common/modals/ResubmitModal';
import SearchResultModal from '../../components/broker/modals/SearchResultModal';
import UploadModal from '../../components/common/modals/UploadModal';
import ViewImageModal from '../../components/individualPortal/dashboard/modals/ViewImageModal';

// Constants

import { commonModalTypes as MODAL_TYPES } from '../../constants/common/modals/commonModalTypes';

/**
 *
 * @param {Object} props - contains "modal" props from Redux Store
 * @returns {React.Component} - modal layout and needed content for Modal
 *
 */
const CommonModalContainer = props => {

    let {
        modal,
        modal: {
            modalType
        },
        ...restProps
    } = props;

    const extendedProps = {
        modal,
        ...restProps
    };

    const getModal = () => {
        switch (modalType) {
            case MODAL_TYPES.ADDED_TO_BOB_MODAL:
                return <AddedToBOBModal { ...extendedProps }/>;

            case MODAL_TYPES.BECOME_AOR_MODAL:
                return <BecomeAORModal { ...extendedProps }/>;

            case MODAL_TYPES.LOCATE_ASSISTANCE_MODAL:
                return <LocateAssistanceModal { ...extendedProps }/>;

            case MODAL_TYPES.SAVE_RESULT_MODAL:
                return <SaveResultModal { ...extendedProps } />;

            case MODAL_TYPES.SESSION_IDLE_WARNING_MODAL:
                return <SessionIdleWarningModal { ...extendedProps }/>;

            case MODAL_TYPES.APP_IN_PROGRESS:
                return <AppInProgressModal { ...extendedProps }/>;

            case MODAL_TYPES.REQUEST_ERROR:
                return  <RequestErrorModal { ...extendedProps }/>;

            case MODAL_TYPES.SEARCH_RESULT_MODAL:
                return <SearchResultModal { ...extendedProps }/>;

            case MODAL_TYPES.UPLOAD_MODAL:
                return <UploadModal { ...extendedProps }/>;

            case MODAL_TYPES.RESUBMIT_MODAL:
                return <ResubmitModal { ...extendedProps } />;

            case MODAL_TYPES.VIEW_IMAGE_MODAL:
                return <ViewImageModal { ...extendedProps } />;
        }
    };

    return getModal();
};

export default CommonModalContainer;
